import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { fill: "#37454d" }, [
      _createElementVNode("path", { d: "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2M4 5h16c.6 0 1 .4 1 1v6c-.3 0-.5.1-.7.3L16 16.6l-6.3-6.3c-.2-.2-.4-.3-.7-.3s-.5.1-.7.3L3 15.6V6c0-.6.4-1 1-1m16 14H4c-.6 0-1-.4-1-1v-1l6-6 7 7 5-5v5c0 .6-.4 1-1 1" }),
      _createElementVNode("path", { d: "M16 11c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2m0-3c.6 0 1 .4 1 1s-.4 1-1 1-1-.4-1-1 .4-1 1-1" })
    ], -1)
  ]))]))
}
export default { render: render }